import { css } from '@genesislcap/web-core';

export const sinkingFundModalStyles = css`
  :host {
    display: block;
    pointer-events: none;
    z-index: 100;
  }

  .sinking-fund-panel {
    background: #1f2126;
    border: 1px solid #505050;
    border-radius: 4px;
    padding: 12px 16px;
    min-width: 220px;
    overflow-y: auto;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.45);
    pointer-events: auto;
  }

  .sinking-fund-heading {
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 10px 0;
  }

  .sinking-fund-table {
    width: 100%;
    border-collapse: collapse;
  }

  .sinking-fund-table th {
    color: #a0a0a0;
    font-size: 12px;
    font-weight: 500;
    text-align: right;
    padding: 4px 8px;
    border-bottom: 1px solid #505050;
    position: sticky;
    top: 0;
    background: #1f2126;
  }

  .sinking-fund-table th:first-child {
    text-align: left;
  }

  .sinking-fund-table td {
    color: #ffffff;
    font-size: 13px;
    padding: 6px 8px;
    text-align: right;
  }

  .sinking-fund-table td:first-child {
    text-align: left;
  }

  .sinking-fund-table tbody tr:not(:last-child) td {
    border-bottom: 1px solid #2a2e33;
  }
`;
